import { render, staticRenderFns } from "./CheckRefOrderItem.vue?vue&type=template&id=33b1dbbe&scoped=true"
import script from "./CheckRefOrderItem.vue?vue&type=script&lang=js"
export * from "./CheckRefOrderItem.vue?vue&type=script&lang=js"
import style0 from "./CheckRefOrderItem.vue?vue&type=style&index=0&id=33b1dbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1dbbe",
  null
  
)

export default component.exports